<div class="dev-comment">src\app\landowner-admin-shared\components\lease-season-form\lease-season-form.component.html</div>

<div *ngIf="value" class="flx-container">
  <ng-container *ngIf="showTitle">
    <div class="flx-item title">Lease Season</div>

    <div class="flx-break"></div>
  </ng-container>

  <div class="flx-item-vertical-center flex-col1">
    <label for="name">Name</label>
    <oapopover class="oa-popover" [title]="'Season Name'" [content]="'A short name that describes the season.'"></oapopover>
    :
  </div>

  <div class="flx-item-vertical-center">
    <input
      type="text"
      name=""
      id="lease-season-name-input"
      class="form-control"
      value=""
      required="required"
      pattern=""
      [(ngModel)]="value.name"
      (ngModelChange)="onChange($event)"
    />
  </div>

  <div class="flx-break"></div>

  <div class="flx-item-vertical-center flex-col1">
    <label for="name">Description</label>
    <oapopover class="oa-popover" [title]="'Season Description'" [content]="'A description of the season.'"></oapopover>
    :
  </div>

  <div class="flx-item-vertical-center">
    <input
      type="text"
      name=""
      id="lease-season-description-input"
      class="form-control"
      value=""
      required="required"
      pattern=""
      [(ngModel)]="value.description"
      (ngModelChange)="onChange($event)"
    />
  </div>

  <div class="flx-break"></div>

  <div class="flx-item-vertical-center flex-col1">
    <label for="startDateTime">Start Date:</label>
  </div>

  <div class="flx-item-vertical-center">
    <oadate-input *ngIf="value" [name]="'startDateTime'" [(value)]="value.startDateTime" (valueChange)="onChange($event)"> </oadate-input>
  </div>

  <div class="flx-item-vertical-center flex-col1">
    <label for="endDateTime">End Date:</label>
  </div>

  <div class="flx-item-vertical-center">
    <oadate-input *ngIf="value" [name]="'endDateTime'" [(value)]="value.endDateTime" (valueChange)="onChange($event)"> </oadate-input>
  </div>

  <div class="flx-break"></div>

  <ng-container *ngIf="dateValidation && !dateValidation.isValid">
    <div class="flx-item">
      <error-list [errorMessages]="dateValidation.issues"> </error-list>
    </div>

    <div class="flx-break"></div>
  </ng-container>

  <div class="flx-item-vertical-center flex-col1">
    <label for="name">Secure Alternate ID</label>
    <oapopover class="oa-popover" [title]="'Secure Alternate ID'" [content]="'A uuid unique identifer for the lease season'"></oapopover>
  </div>

  <div class="flx-item-vertical-center text-muted">
    <!-- <input disabled type="text" name="secureAlternateId" id="input-secureAlternateId" class="form-control"required="required" pattern="" title="" [(ngModel)]="value.secureAlternateId" /> -->

    {{ value.secureAlternateId }}
  </div>

  <div class="flx-break"></div>

  <div class="flx-item-vertical-center flex-col1">
    <label for="name">Created On:</label>
  </div>

  <div class="flx-item-vertical-center">
    <!-- <input disabled type="text" name="secureAlternateId" id="input-secureAlternateId" class="form-control"required="required" pattern="" title="" [(ngModel)]="value.secureAlternateId" /> -->

    {{ value.createdOn | date: "short" }}
  </div>

  <div class="flx-break"></div>

  <div class="flx-item-vertical-center flex-col1">
    <label for="name">Created By:</label>
  </div>

  <div class="flx-item-vertical-center">
    <!-- <input disabled type="text" name="secureAlternateId" id="input-secureAlternateId" class="form-control"required="required" pattern="" title="" [(ngModel)]="value.secureAlternateId" /> -->

    {{ value.createdBy | username | async }}
  </div>

  <div class="flx-break"></div>

  <ng-container *ngIf="validations && !validations.isValid">
    <div class="flx-item">
      <error-list [errorMessages]="validations.issues"> </error-list>
    </div>

    <div class="flx-break"></div>
  </ng-container>

  <div *ngIf="fieldValidationResult['name'] && fieldValidationResult['name'].issues.length" class="flx-left">
    <error-list [errorMessages]="this.fieldValidationResult['name'].issues"> </error-list>
  </div>

  <div class="flx-item">
    <action-button
      [disabled]="!valid"
      [class]="'btn btn-primary btn-round el-125px'"
      [name]="'lease-season-form-save-button'"
      (mouseenter)="onSaveButtonMouseEnter($event)"
      (mouseleave)="onSaveButtonMouseLeave($event)"
      (click)="onSaveClick($event)"
    >
      Save
    </action-button>

    <action-button
      [class]="'btn btn-primary btn-round el-125px'"
      [name]="'lease-season-form-cancel-button'"
      (click)="onCancelClick($event)"
    >
      Cancel
    </action-button>
  </div>
</div>
